<button
  [ngClass]="{ selected: path[3] === 'new' }"
  mat-stroked-button
  (click)="goTo('new')"
>
  {{ 'UPSELLING.BUTTON_NEW_DEVICE' | translation }}
</button>

<button
  [ngClass]="{ selected: path[3] === 'buy' }"
  (click)="goTo('buy')"
  mat-stroked-button
>
  {{ 'UPSELLING.BUTTON_BUY_DEVICE' | translation }}
</button>
